<template>
	<div style="overflow:hidden; width:100% ">
		<template v-for="(param_, p1) in array_files_params">
			<div style="background-color: #E5E5E5; padding:10px;width:100%">
				<div style="padding-top: 10px; padding-bottom: 10px;"><b>{{param_.name}}</b></div>
				<div class="wrap_firmas" style="overflow:auto; width:fit-content">
					<div id="content_coordenadas">
						<div :id="div_name" :class="'doc-id-'+param_.doc_id" :style="'height:'+param_.height + 'px;'+'width:'+param_.width + 'px;'"></div>
						<canvas :id="'canvas-'+param_.doc_id" :width="param_.width" :height="param_.height" :pages="param_.pages" ></canvas>
					</div>
				</div>
			</div>
		</template>
	</div>
</template>
<script>
	export default {
		props: ['array_files_params', 'div_name'],
		data: function() {
		  return {
		  	
		  };
		},
  	computed: {

  	},
  	mounted() {
  		
  	},
  	methods: {

  	},
	};
</script>